<script lang="ts">
export default {
  name: 'Tooltip',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    text: string;
    position?: 'top' | 'bottom' | 'left' | 'right';
    disabled?: boolean;
    class?: string;
  }>(),
  {
    position: 'top',
    disabled: false,
  },
);

const wrapperClasses = computed(() => {
  const classes = ['tw:tooltip'];
  switch (props.position) {
    case 'bottom':
      classes.push('tw:tooltip-bottom');
      break;
    case 'left':
      classes.push('tw:tooltip-left');
      break;
    case 'right':
      classes.push('tw:tooltip-right');
      break;
    case 'top':
    default:
      classes.push('tw:tooltip-top');
      break;
  }
  if (props.class) {
    classes.push(props.class);
  }
  return classes.join(' ');
});
</script>

<template>
  <span
    :class="disabled ? props.class : wrapperClasses"
    :data-tip="disabled ? undefined : text">
    <slot />
  </span>
</template>
